import { useEffect } from 'react';

let activeBackdropCount = 0;
let previousBodyOverflow = '';
let previousBodyPaddingRight = '';
let previousDocumentElementOverflow = '';

function ModalBackdrop({
  children,
  backdropClassName = 'bg-[rgba(33,27,22,0.24)]',
  className = '',
  contentClassName = '',
  zIndexClassName = 'z-50',
}) {
  useEffect(() => {
    const { body, documentElement } = document;

    if (activeBackdropCount === 0) {
      const scrollbarWidth = window.innerWidth - documentElement.clientWidth;

      previousBodyOverflow = body.style.overflow;
      previousBodyPaddingRight = body.style.paddingRight;
      previousDocumentElementOverflow = documentElement.style.overflow;
      body.style.overflow = 'hidden';
      documentElement.style.overflow = 'hidden';

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    activeBackdropCount += 1;

    return () => {
      activeBackdropCount = Math.max(activeBackdropCount - 1, 0);

      if (activeBackdropCount === 0) {
        body.style.overflow = previousBodyOverflow;
        body.style.paddingRight = previousBodyPaddingRight;
        documentElement.style.overflow = previousDocumentElementOverflow;
      }
    };
  }, []);

  return (
    <div className={`fixed inset-0 ${zIndexClassName} overflow-y-auto ${backdropClassName} ${className}`}>
      <div className={`flex min-h-full w-full items-start justify-center px-4 py-6 sm:px-6 ${contentClassName}`}>
        {children}
      </div>
    </div>
  );
}

export default ModalBackdrop;
